import { render } from "./global.vue?vue&type=template&id=5fc30f92"
import script from "./global.vue?vue&type=script&lang=js"
export * from "./global.vue?vue&type=script&lang=js"

import "./global.vue?vue&type=style&index=0&id=5fc30f92&lang=css"

import exportComponent from "E:\\Proyectos\\Front_IOSEP\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__